"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralAudioTypeToJSON = exports.GeneralAudioTypeFromJSONTyped = exports.GeneralAudioTypeFromJSON = exports.GeneralAudioType = void 0;
/**
 * The general type of audio asset, with ADSTUDIO_SUPPLIED_AUDIO and USER_UPLOADED_AUDIO being included as part of the AUDIO_AD categorization.
 * @export
 */
exports.GeneralAudioType = {
    AudioAd: 'AUDIO_AD',
    BackgroundMusic: 'BACKGROUND_MUSIC'
};
function GeneralAudioTypeFromJSON(json) {
    return GeneralAudioTypeFromJSONTyped(json, false);
}
exports.GeneralAudioTypeFromJSON = GeneralAudioTypeFromJSON;
function GeneralAudioTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GeneralAudioTypeFromJSONTyped = GeneralAudioTypeFromJSONTyped;
function GeneralAudioTypeToJSON(value) {
    return value;
}
exports.GeneralAudioTypeToJSON = GeneralAudioTypeToJSON;
